<script setup lang="ts" name="RegistrationList">
import { REGISTRATION_SEARCH_OPTION_TYPE } from '~/constants';

import RegistrationSearchSelectMultiple from '~/components/RegistrationSearchSelectMultiple.vue';

import type { IRegistrationHighlightedOption } from '~/types';

defineProps<{
  tradelanesOptions: IRegistrationHighlightedOption[];
  portsOptions: IRegistrationHighlightedOption[];
  countriesOptions: IRegistrationHighlightedOption[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', options: IRegistrationHighlightedOption): void;
}>();
</script>

<template>
  <RegistrationSearchSelectMultiple
    v-if="tradelanesOptions.length"
    data-test="registration-search-trades"
    :title="REGISTRATION_SEARCH_OPTION_TYPE.TRADES"
    :options="tradelanesOptions"
    @update:model-value="emit('update:modelValue', $event)"
  />

  <RegistrationSearchSelectMultiple
    v-if="portsOptions.length"
    data-test="registration-search-ports"
    :title="REGISTRATION_SEARCH_OPTION_TYPE.PORTS"
    :options="portsOptions"
    @update:model-value="emit('update:modelValue', $event)"
  />

  <RegistrationSearchSelectMultiple
    v-if="countriesOptions.length"
    data-test="registration-search-countries"
    :title="REGISTRATION_SEARCH_OPTION_TYPE.COUNTRIES"
    :options="countriesOptions"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
